const storageLocaleKey = 'locale'

export const getStoredLocale = (): string | null => localStorage.getItem(storageLocaleKey)

export const setStoredLocale = (locale: string): void =>
  localStorage.setItem(storageLocaleKey, locale)
